export const GENERATE_MENTALIST_REPORT_REQUEST = "GENERATE_MENTALIST_REPORT_REQUEST";
export const GENERATE_MENTALIST_REPORT_SUCCESS = "GENERATE_MENTALIST_REPORT_SUCCESS";
export const GENERATE_MENTALIST_REPORT_FAILURE = "GENERATE_MENTALIST_REPORT_FAILURE";
